import React from "react";
import {  routes } from "./constants";
import "./help.scss";
import "./help-categories.scss";
import { useCommonContext } from "../../context/common-context";

const HelpCategories = ({  id, filterBy }) => {
  const {
    bannerCategories,
    user,
    appData: { banner },
    isGuest,
  } = useCommonContext();
  const [showSeeAll, setShowSeeAll] = React.useState(true);
  const [showTitle, setShowTitle] = React.useState(true);
  const [categories, setCategories] = React.useState([]);

  React.useEffect(() => {
    const allFaq = Object.values(routes);
    const isAllFaqPage = window.location.pathname.split('/').filter((array => {
        return allFaq.includes(array);
    })).length > 0;

    setShowSeeAll(isAllFaqPage ? false : showSeeAll);
    setShowTitle(!isAllFaqPage);
    const filteredList = bannerCategories.filter((category) => {
      switch (filterBy) {
        case 'topFaq':  return category.topFaq;
        case 'parentId': return category.parentId === id;
        case '': return showSeeAll ? category.topCategory : !category.parentId;
          default: return true;
      }
    });
    setCategories(filteredList);
  }, [showSeeAll, banner]);

  const handleViewAll = React.useCallback(() => {
    setShowSeeAll(false);
  }, [setShowSeeAll]);

  return (
    <div className="help-categories-wrapper">
      <div className="mt-3 row">
        {showTitle && (
          <div class="btn col-auto text-left">
            <h3 className="sub-title m-0 font-weight-600">Top Categories</h3>
          </div>
        )}
        <div className="col pl-0">
          {showSeeAll ? (
            <button
              onClick={handleViewAll}
              className="btn homepage-nav font-weight-600 link m-auto font-size-16"
              aria-label="Top Categories View All"
            >
              {" "}
              View All
            </button>
          ) : null}
        </div>
      </div>
      <ul className="category-tiles pl-3 row">
        {categories.map((Category) => {
          return (
            <Category.Card
              category={Category}
              isGuest={isGuest}
              user={user}
              banner={banner}
            />
          )
        })}
      </ul>
    </div>
  );
};

export default React.memo(HelpCategories);
